import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { useState } from 'react';
import { Download, Paperclip } from 'lucide-react';
import { RenderAttachmentProps } from 'stream-chat-react';
import { PdfViewer } from '@/components/pdf-viewer/pdf-viewer';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { Button } from '@/components/ui/button';

export const PdfAttachmentContainer = (props: RenderAttachmentProps) => {
  const [isPdfDialogOpen, setIsPdfDialogOpen] = useState(false);

  const handleDownload = async () => {
    const response = await fetch(props.attachment.asset_url!);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = props.attachment.title || 'document.pdf';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <div
        className="str-chat__message-attachment-file--item p-2 flex items-center justify-center"
        onClick={() => setIsPdfDialogOpen(true)}
      >
        <div className="w-5 h-5">
          <Paperclip className="w-5 h-5" />
        </div>

        <div>
          <div className="str-chat__message-attachment-file--item-name cursor-pointer hover:underline">
            {props.attachment.title}
          </div>
        </div>
      </div>

      <Dialog open={isPdfDialogOpen} onOpenChange={setIsPdfDialogOpen}>
        <VisuallyHidden>
          <DialogTitle>PDF Document</DialogTitle>
        </VisuallyHidden>
        <DialogContent className="min-w-[75vw] h-[97vh] p-10">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold">{props.attachment.title}</h2>
            <Button onClick={handleDownload} variant="outline" className="flex items-center gap-2">
              <Download className="w-4 h-4" />
              <p>Download</p>
            </Button>
          </div>
          <PdfViewer pdfUrl={props.attachment.asset_url!} />
        </DialogContent>
      </Dialog>
    </>
  );
};
